import { Component, inject, input } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { DialogService } from '../core/dialog.service';
import { InvoiceService } from '../core/invoice.service';

@Component({
    selector: 'app-sign-in',
    imports: [FormsModule],
    template: `
        <div class="master-column-wrapper">
            @if (auth.loggedInCustomer()) {
                <div class="page login-page">
                    <div class="page-title">
                        <h1>Hello {{ auth.loggedInCustomer()?.companyName }}</h1>
                    </div>
                    <div class="page-body">
                        <div class="returning-wrapper fieldset">
                            <div class="buttons"><button class="button-1 login-button" (click)="logout()">Log out</button></div>
                        </div>
                    </div>
                </div>
            } @else {
                <div class="page login-page">
                    <div class="page-title"><h1>Sign in or register to checkout now</h1></div>
                    <div class="page-body">
                        <div class="x-customer-blocks">
                            <div class="returning-wrapper fieldset">
                                <div class="title"><strong>Returning Customer</strong></div>
                                <div class="form-fields">
                                    <div class="inputs">
                                        <label for="Email">Email:</label>
                                        <input [(ngModel)]="model.email" class="email" type="email" id="Email" name="Email" required />
                                        <span class="field-validation-valid" data-valmsg-for="Email" data-valmsg-replace="true"></span>
                                        <div
                                            data-lastpass-icon-root="true"
                                            style="position: relative !important; height: 0px !important; width: 0px !important; float: left !important;"
                                        ></div>
                                    </div>
                                    <div class="inputs">
                                        <label for="Password">Password:</label>
                                        <input
                                            class="password"
                                            [(ngModel)]="model.password"
                                            type="password"
                                            id="Password"
                                            name="Password"
                                        />
                                        <span class="field-validation-valid"></span>
                                        <div
                                            style="position: relative !important; height: 0px !important; width: 0px !important; float: left !important;"
                                        ></div>
                                    </div>
                                    <!-- <div class="inputs reversed">
                                        <input type="checkbox" data-val="true" id="RememberMe" name="RememberMe" value="true" />
                                        <label for="RememberMe">Remember me?</label>
                                        <span class="forgot-password"> <a href="/password-recovery">Forgot password?</a> </span>
                                    </div> -->
                                </div>
                                <!-- <div>model = {{ model.email }}, {{ model.password }}</div> -->
                                <div class="buttons"><button class="button-1 login-button" (click)="login()">Log in</button></div>
                            </div>
                            <div class="checkout-as-guest-or-register-block" style="margin-top: 60px;">
                                <div class="title">
                                    <strong>{{ showGuest() ? 'Checkout as a guest or register' : 'Register now' }}</strong>
                                </div>
                                <div class="text">
                                    <div class="topic-block">
                                        <div class="topic-block-body" style="margin: 0 50px;">
                                            <p><strong>Register and save time!</strong><br />Register with us for future convenience:</p>
                                            <ul>
                                                <li>Fast and easy check out</li>
                                                <li>Get the best pricing available as your purchase more</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="buttons">
                                    @if (showGuest()) {
                                        <button
                                            type="button"
                                            class="button-1 checkout-as-guest-button"
                                            style="margin-right: 5px;"
                                            (click)="continue()"
                                        >
                                            Checkout as Guest
                                        </button>
                                    }
                                    <button type="button" class="button-1 register-button" (click)="register()">Register</button>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="external-authentication"></div> -->
                        <!-- <div class="topic-block">
                            <div class="topic-block-title"><h2>About login / registration</h2></div>
                            <div class="topic-block-body">
                                <p>Put your login / registration information here. You can edit this in the admin site.</p>
                            </div>
                        </div> -->
                    </div>
                </div>
            }
        </div>
    `,
    styles: `
        .inputs label {
            width: 100px;
        }
    `
})
export class SignInComponent {
    router = inject(Router);
    route = inject(ActivatedRoute);
    auth = inject(AuthService);
    dialogService = inject(DialogService);
    invoiceService = inject(InvoiceService);

    model = {
        email: '',
        password: ''
    };

    showGuest = input<boolean>(false);

    continue() {
        this.router.navigate(['../billing'], { relativeTo: this.route });
    }

    register() {
        this.router.navigate(['../register'], { relativeTo: this.route });
    }

    async login() {
        if (!this.model.email || !this.model.password) return;

        const result = await this.auth.login(this.model.email, this.model.password);
        if (!result.isSuccess) {
            this.dialogService.alert(result.detail ?? 'Login failed. Please try again.');
            return;
        }

        this.invoiceService.refreshInvoice();

        if (this.showGuest()) {
            this.router.navigate(['../billing'], { relativeTo: this.route });
            return;
        }
        // this.router.navigate(['../checkout'], { relativeTo: this.route });

        // this.router.navigate(['../billing'], { relativeTo: this.route });
    }

    async logout() {
        await this.auth.logout();
        this.router.navigate(['/']);
    }
}
